import { render, staticRenderFns } from "./FieldCustomerLink.vue?vue&type=template&id=03f43b4c&scoped=true&"
import script from "./FieldCustomerLink.vue?vue&type=script&lang=js&"
export * from "./FieldCustomerLink.vue?vue&type=script&lang=js&"
import style0 from "./FieldCustomerLink.vue?vue&type=style&index=0&id=03f43b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f43b4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03f43b4c')) {
      api.createRecord('03f43b4c', component.options)
    } else {
      api.reload('03f43b4c', component.options)
    }
    module.hot.accept("./FieldCustomerLink.vue?vue&type=template&id=03f43b4c&scoped=true&", function () {
      api.rerender('03f43b4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldCustomerLink.vue"
export default component.exports